import { render, staticRenderFns } from "./RegistratiesBase.vue?vue&type=template&id=0e66702c&scoped=true&"
import script from "./RegistratiesBase.vue?vue&type=script&lang=js&"
export * from "./RegistratiesBase.vue?vue&type=script&lang=js&"
import style0 from "./RegistratiesBase.vue?vue&type=style&index=0&id=0e66702c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66702c",
  null
  
)

export default component.exports